"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconDots = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconDots = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M12.313 20.588c-.51 0-.945-.182-1.306-.545-.36-.363-.54-.8-.54-1.31s.181-.944.544-1.305c.364-.36.8-.54 1.31-.54s.945.181 1.305.544c.36.363.54.8.54 1.31s-.18.945-.544 1.305c-.363.36-.8.54-1.31.54Zm0-6.67c-.51 0-.945-.181-1.306-.544-.36-.363-.54-.8-.54-1.31s.181-.944.544-1.305c.364-.36.8-.54 1.31-.54s.945.181 1.305.544c.36.363.54.8.54 1.31s-.18.944-.544 1.305c-.363.36-.8.54-1.31.54Zm0-6.669c-.51 0-.945-.181-1.306-.544-.36-.363-.54-.8-.54-1.31s.181-.945.544-1.305c.364-.36.8-.54 1.31-.54s.945.18 1.305.544c.36.363.54.8.54 1.31 0 .509-.18.944-.544 1.305-.363.36-.8.54-1.31.54Z"
}));
exports.IconDots = IconDots;
//# sourceMappingURL=IconDots.js.map